import { notification } from "antd";
import { t } from "i18next";

class ToastService {
  success = (desc: string) => {
    notification.success({
      // message: t("TOAST.USPEH"),
      message: t(desc),
      // description: t(desc),
    });
  };

  info = (desc: string) => {
    notification.info({
      message: t("TOAST.INFO"),
      description: t(desc),
    });
  };

  error = (desc: string) => {
    notification.error({
      message: t("TOAST.GRESKA"),
      description: t(desc),
    });
  };
}

export const toastService = new ToastService();
